import { createSelector } from 'reselect'
import { get } from 'lodash'

import key from './types'
import { initialState } from './reducer'

const selectAffiliateCategories = state => get(state, key, initialState)

const selectLoading = createSelector(
  selectAffiliateCategories, state => get(state, 'loading', null)
)

const selectLoadingAffiliateCategories = createSelector(
  selectAffiliateCategories, state => get(state, 'affiliateCategoriesLoading', null)
)

const selectSuccess = createSelector(
  selectAffiliateCategories, state => get(state, 'affiliateCategoriesList', [])
)

const selectColumns = createSelector(
  selectAffiliateCategories, state => get(state, 'columns', [])
)

const selectPages = createSelector(
  selectAffiliateCategories, state => get(state, 'pages', null)
)

const selectTotalItems = createSelector(
  selectAffiliateCategories, state => get(state, 'totalItems', 0)
)

const selectError = createSelector(
  selectAffiliateCategories, state => get(state, 'error', null)
)

const selectDataFilters = createSelector(
  selectAffiliateCategories, state => get(state, 'dataFilters', [])
)

const selectDataFiltersError = createSelector(
  selectAffiliateCategories, state => get(state, 'dataFiltersError', null)
)

const selectSetAffiliateCategoryInformation = createSelector(
  selectAffiliateCategories, state => get(state, 'affiliateCategoryInformation', null)
)

export default {
  SUCCESS: selectSuccess,
  COLUMNS: selectColumns,
  ERROR: selectError,
  LOADING: selectLoading,
  LOADING_LIST: selectLoadingAffiliateCategories,
  PAGES: selectPages,
  TOTAL_ITEMS: selectTotalItems,

  FILTER_OBJECT: selectDataFilters,
  ERROR_FILTER_OBJECT: selectDataFiltersError,
  SET_AFFILIATE_CATEGORY_INFORMATION: selectSetAffiliateCategoryInformation
}
